/**
 * A24-style quantity selector.
 *
 * A24's product page replaces the − 1 + stepper with a tight row of digits
 * 1…9; the chosen one is black, the rest grey, and clicking one sets the
 * quantity. This is a progressive-enhancement layer over Dawn's
 * <quantity-input>: we hide the stepper, render the digit row, and write the
 * picked value straight into Dawn's real <input name="quantity"> (dispatching
 * input/change so its cart + price-break logic still runs).
 */
(function () {
  'use strict';

  var MAX_DIGITS = 9;

  function build(qtyInput) {
    if (qtyInput.dataset.a24Qty) return;
    var input = qtyInput.querySelector('input[name="quantity"], .quantity__input');
    if (!input) return;
    qtyInput.dataset.a24Qty = '1';

    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var maxAttr = parseInt(input.getAttribute('max'), 10);
    var count = MAX_DIGITS;
    if (!isNaN(maxAttr) && maxAttr > 0) count = Math.min(MAX_DIGITS, maxAttr);
    if (count < min) count = min;

    var row = document.createElement('div');
    row.className = 'a24-qty';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', 'Quantity');

    var buttons = [];
    for (var n = min; n < min + count; n++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'a24-qty__opt';
      b.textContent = String(n);
      b.dataset.value = String(n);
      row.appendChild(b);
      buttons.push(b);
    }

    function sync() {
      var v = parseInt(input.value, 10) || min;
      buttons.forEach(function (b) {
        b.classList.toggle('is-active', parseInt(b.dataset.value, 10) === v);
      });
    }

    row.addEventListener('click', function (e) {
      var b = e.target.closest('.a24-qty__opt');
      if (!b) return;
      input.value = b.dataset.value;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      sync();
    });
    input.addEventListener('change', sync);

    // a Dawn variant re-render can leave a stale row behind — clear it first
    if (qtyInput.nextElementSibling && qtyInput.nextElementSibling.classList.contains('a24-qty')) {
      qtyInput.nextElementSibling.remove();
    }
    qtyInput.insertAdjacentElement('afterend', row);
    qtyInput.classList.add('a24-qty-hidden');
    sync();
  }

  function run(root) {
    // PDP quantity block only — the bare `.quantity` selector also matches the
    // cart drawer / cart page line-item steppers, and hiding those breaks the
    // cart's +/- control.
    (root || document)
      .querySelectorAll('.product-form__quantity quantity-input, .product-form__quantity .quantity')
      .forEach(build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { run(); }, { once: true });
  } else {
    run();
  }
  // variant switches re-render the product form
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
  document.addEventListener('a24:product-form-updated', function () { run(); });
})();
